/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PaxCheckIdMismatches, PaxCheckIdMismatchesFromJSONTyped, PaxCheckIdMismatchesToJSON } from "./PaxCheckIdMismatches";
import { PaxCheckNoItemsToApplyDocumentTo, PaxCheckNoItemsToApplyDocumentToFromJSONTyped, PaxCheckNoItemsToApplyDocumentToToJSON } from "./PaxCheckNoItemsToApplyDocumentTo";
import { PaxCheckRulesMismatches, PaxCheckRulesMismatchesFromJSONTyped, PaxCheckRulesMismatchesToJSON } from "./PaxCheckRulesMismatches";
import { PaxCheckSignalsMismatches, PaxCheckSignalsMismatchesFromJSONTyped, PaxCheckSignalsMismatchesToJSON } from "./PaxCheckSignalsMismatches";
import { PaxCheckTravelDocumentRequired, PaxCheckTravelDocumentRequiredFromJSONTyped, PaxCheckTravelDocumentRequiredToJSON } from "./PaxCheckTravelDocumentRequired";


/**
 * @type PaxCheckApplyDocumentError
 * 
 * @export
 */
export type PaxCheckApplyDocumentError = { type: 'id-mismatches' } & PaxCheckIdMismatches | { type: 'no-items-to-apply-document-to' } & PaxCheckNoItemsToApplyDocumentTo | { type: 'provide-passport' } & PaxCheckTravelDocumentRequired | { type: 'rules-mismatches' } & PaxCheckRulesMismatches | { type: 'signals-mismatches' } & PaxCheckSignalsMismatches;

export function PaxCheckApplyDocumentErrorFromJSON(json: any): PaxCheckApplyDocumentError {
    return PaxCheckApplyDocumentErrorFromJSONTyped(json, false);
}

export function PaxCheckApplyDocumentErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckApplyDocumentError {
    if (json == null) {
        return json;
    }
    switch (json['type']) {
        case 'id-mismatches':
            return Object.assign({}, PaxCheckIdMismatchesFromJSONTyped(json, true), { type: 'id-mismatches' } as const);
        case 'no-items-to-apply-document-to':
            return Object.assign({}, PaxCheckNoItemsToApplyDocumentToFromJSONTyped(json, true), { type: 'no-items-to-apply-document-to' } as const);
        case 'provide-passport':
            return Object.assign({}, PaxCheckTravelDocumentRequiredFromJSONTyped(json, true), { type: 'provide-passport' } as const);
        case 'rules-mismatches':
            return Object.assign({}, PaxCheckRulesMismatchesFromJSONTyped(json, true), { type: 'rules-mismatches' } as const);
        case 'signals-mismatches':
            return Object.assign({}, PaxCheckSignalsMismatchesFromJSONTyped(json, true), { type: 'signals-mismatches' } as const);
        default:
            return json;
    }
}

export function PaxCheckApplyDocumentErrorToJSON(json: any): any {
    return PaxCheckApplyDocumentErrorToJSONTyped(json, false);
}

export function PaxCheckApplyDocumentErrorToJSONTyped(value?: PaxCheckApplyDocumentError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['type']) {
        case 'id-mismatches':
            return Object.assign({}, PaxCheckIdMismatchesToJSON(value), { type: 'id-mismatches' } as const);
        case 'no-items-to-apply-document-to':
            return Object.assign({}, PaxCheckNoItemsToApplyDocumentToToJSON(value), { type: 'no-items-to-apply-document-to' } as const);
        case 'provide-passport':
            return Object.assign({}, PaxCheckTravelDocumentRequiredToJSON(value), { type: 'provide-passport' } as const);
        case 'rules-mismatches':
            return Object.assign({}, PaxCheckRulesMismatchesToJSON(value), { type: 'rules-mismatches' } as const);
        case 'signals-mismatches':
            return Object.assign({}, PaxCheckSignalsMismatchesToJSON(value), { type: 'signals-mismatches' } as const);
        default:
            return value;
    }
}

